import { render, staticRenderFns } from "./WaardenResultsBody.vue?vue&type=template&id=4e13f86e&scoped=true&"
import script from "./WaardenResultsBody.vue?vue&type=script&lang=js&"
export * from "./WaardenResultsBody.vue?vue&type=script&lang=js&"
import style0 from "./WaardenResultsBody.vue?vue&type=style&index=0&id=4e13f86e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e13f86e",
  null
  
)

export default component.exports